import React from 'react'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import CloseIcon from '@mui/icons-material/Close'
import DragHandleIcon from '@mui/icons-material/DragHandle'
import { ReactComponent as DivisionIcon } from 'src/static/media/division.svg'
import { ReactComponent as PercentDownIcon } from 'src/static/media/percentDown.svg'
import { ReactComponent as PercentUpIcon } from 'src/static/media/percentUp.svg'
import './style.css'

export const operators = [
  { id: 1, isOperator: true, operator: 'assign', icon: <DragHandleIcon key='icon' />, color: '#aab1e6' },
  { id: 2, isOperator: true, operator: 'add', icon: <AddIcon key='icon' />, color: '#4ec6d9' },
  { id: 3, isOperator: true, operator: 'sub', icon: <RemoveIcon key='icon' />, color: '#8dd6e5' },
  { id: 4, isOperator: true, operator: 'mul', icon: <CloseIcon key='icon' />, color: '#c5e6ed' },
  {
    id: 5,
    isOperator: true,
    operator: 'truediv',
    icon: <DivisionIcon className='operator-icon' key='icon' />,
    color: '#e1eef1',
  },
  {
    id: 6,
    isOperator: true,
    operator: 'percentage_down',
    icon: <PercentDownIcon className='operator-icon' key='icon' />,
    color: '#0eabbe',
    detail: { text: 'Porcentaje', background: 'lightgray' },
  },
  {
    id: 7,
    isOperator: true,
    operator: 'percentage_up',
    icon: <PercentUpIcon className='operator-icon' key='icon' />,
    color: '#0eabbe',
    detail: { text: 'Porcentaje', background: 'lightgray' },
  },
]
